<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-form ref="formPassword" v-model="formPassword">
      <v-card>
        <v-toolbar color="primary" dense dark>
          <v-toolbar-title>Assinatura Eletrônica</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text dark @click="validate" :disabled="!formPassword">Validar</v-btn>
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container fluid>
          <v-row class="mt-4">
            <v-col sm="12">
              <v-text-field
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :type="show ? 'text' : 'password'"
                dense
                v-model="password"
                :rules="[rules.required]"
                @click:append="show = !show"
                label="Digite sua senha"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import store from '@/store';
import * as HANDLERS from '@/helpers/types/handlers';
import { sleep } from '@/helpers/page';

export default {
  props: {
    dialog: { type: Boolean, default: false },
    params: { type: Object }
  },

  data: () => ({
    rules: {
      required: v => !!v || 'Este campo é obrigatório'
    },
    formPassword: false,
    password: null,
    show: false
  }),

  events: {
    [HANDLERS.CLOSE_DIALOG_ELECTRONIC_SIGNATURE]: 'close'
  },

  methods: {
    async close() {
      await sleep(100);
      this.$refs.formPassword.reset();
      this.$emit('closeDialogPassword');
    },

    async validate() {
      if (!this.$refs.formPassword.validate(true)) return;

      await store.dispatch('page/checkEletronicSignature', {
        page: this.params.page,
        mode: this.params.mode,
        origin: this.params.origin,
        action: this.params.action,
        master: this.params.master,
        child: this.params.child,
        name: this.params.action.before.procedure.name,
        model: { [this.params.action.before.procedure.model]: this.password }
      });
    }
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    }
  }
};
</script>
